<template>
  <label
    class="sorting__option"
    :class="[
      { 'sorting__option--selected': isSelected },
      { 'sorting__option--first': index === 0 },
      'sorting__option--' + option.code,
    ]"
    :for="'checkbox--' + option.code"
    @click="$emit('selected', option)"
  >
    {{ $t(`${option.code}`) }}
    <input
      type="radio"
      :id="'checkbox--' + option.code"
      class="sorting__checkbox"
      :name="name"
      :checked="isSelected"
    />
  </label>
</template>

<script>
export default {
  name: 'SortingOption',
  props: {
    name: { type: String, required: true },
    option: { type: Object, required: true },
    activeOption: { type: Object, required: true },
    index: { type: Number, required: true },
  },
  computed: {
    isSelected() {
      return this.activeOption.code === this.option.code
    },
  },
}
</script>

<style lang="scss" scoped>
@import './SortingOption';
</style>

<i18n src="@/locales/sorting_option.json">
</i18n>
